import React, { Dispatch, FC, Fragment, useState } from "react";
import { Box, FormControl, Grid, InputLabel, Select } from "@mui/material";
import { useStyles } from "../styles";
import CheckAttr from "../../../utils/CheckAttr";
import { LoadingButton } from "@mui/lab";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { AllMounth, yearsToDisplay } from "../../../constants/Constants";
import { AlertType } from "../../../types/AlertType";
import { AxiosInstance } from "axios";
import { DataRef } from "../../../types/DataRef";
import { downloadFile } from "../../../utils/utils";

interface ExtractData {
    pays: number;
    month: number;
    year: number;
}

interface ExportBudgetFormProps {
    dataPaysInAssociations: DataRef[];
    http: AxiosInstance;
    setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
    setAlerteMessage: Dispatch<React.SetStateAction<string>>;
    setAlertType: Dispatch<React.SetStateAction<AlertType>>;
    onClose: () => void;
}

const ExportBudget: FC<ExportBudgetFormProps> = ({
    dataPaysInAssociations,
    http,
    setOpenSnack,
    setAlerteMessage,
    setAlertType,
    onClose
}) => {
    const classes = useStyles();

    const [isClickExtractBtn, setIsClickExtractBtn] = useState<boolean>(false);
    const [isNotValidate, setIsNotValidate] = useState<boolean>(false);

    const [extractData, setExtractData] = useState<ExtractData>();

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setExtractData({
            ...extractData as ExtractData,
            [name]: value
        });
    };

    const handleExtract = () => {
        setIsNotValidate(false);
        if (CheckAttr(extractData?.year)) {
            setIsClickExtractBtn(true);

            http.post('budget/extract', extractData)
                .then(res => {
                    const { isSucess, message, filename } = res.data;

                    if (isSucess) {
                        downloadFile(filename as string);
                        setAlerteMessage(message);
                        setAlertType("success");
                        setOpenSnack(true);
                        onClose();
                    } else {
                        setAlertType("error");
                        setOpenSnack(true);
                    }
                }).catch(error => {
                    setAlertType("error");
                    setOpenSnack(true);
                    console.log(error);
                }).finally(() => {
                    setIsClickExtractBtn(false);
                });
        } else {
            setAlerteMessage("Merci de choisir une année SVP !");
            setAlertType("warning");
            setOpenSnack(true);

            setIsNotValidate(true);
        }
    };

    return (
        <Fragment>
            <Box className={classes.root} mb={5}>
                <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }}>
                    <Grid item xs={6} sm={6} md={6}>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            sx={{ marginLeft: 1, marginTop: 1 }}
                        >
                            <InputLabel
                                htmlFor="pays"
                                color="warning"
                                shrink={CheckAttr(extractData?.pays)}
                            >
                                Pays de production
                            </InputLabel>
                            <Select
                                id="pays"
                                native
                                color="warning"
                                value={extractData?.pays}
                                onChange={handleChange}
                                label="Pays de production"
                                inputProps={{
                                    name: "pays",
                                }}
                            >
                                <option value=""></option>
                                {dataPaysInAssociations.map((pays) => (
                                    <option key={pays?.id} value={pays?.id}>
                                        {pays?.libelle}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            sx={{ marginLeft: 1, marginTop: 1 }}
                        >
                            <InputLabel
                                htmlFor="year"
                                color="warning"
                                shrink={CheckAttr(extractData?.year)}
                            >
                                Année
                            </InputLabel>
                            <Select
                                id="year"
                                native
                                color="warning"
                                value={extractData?.year}
                                onChange={handleChange}
                                error={isNotValidate}
                                label="Année"
                                inputProps={{
                                    name: "year",
                                }}
                            >
                                <option value=""></option>
                                {yearsToDisplay.map((year) => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={6} sm={6} md={6}>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            sx={{ marginLeft: 1, marginTop: 1 }}
                        >
                            <InputLabel
                                htmlFor="month"
                                color="warning"
                                shrink={CheckAttr(extractData?.month)}
                            >
                                Mois
                            </InputLabel>
                            <Select
                                id="month"
                                native
                                color="warning"
                                value={extractData?.month}
                                onChange={handleChange}
                                label="Mois"
                                inputProps={{
                                    name: "month",
                                }}
                            >
                                <option value=""></option>
                                {AllMounth.map((month) => (
                                    <option key={month?.id} value={month?.id}>
                                        {month?.mounth}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Box>

            <Box display="flex" justifyContent="center" mt={5}>
                <LoadingButton
                    onClick={() => handleExtract()}
                    endIcon={<FileDownloadIcon />}
                    loading={isClickExtractBtn}
                    loadingPosition="end"
                    sx={{ textTransform: "none" }}
                    variant="contained"
                    color="warning"
                >
                    Extraire
                </LoadingButton>
            </Box>
        </Fragment>
    );
};

export default ExportBudget;